"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventFilterParamsSchema = exports.EventFilterFieldSchema = void 0;
const zod_1 = require("zod");
const util_1 = require("./util");
const query_1 = require("./query");
const eventFilter_1 = require("./eventFilter");
exports.EventFilterFieldSchema = zod_1.z.union([...(0, util_1.schemaKeys)(eventFilter_1.EventFilterSchema)]);
exports.EventFilterParamsSchema = (0, query_1.paramsSchema)(exports.EventFilterFieldSchema);
//# sourceMappingURL=eventFilterQuery.js.map